import { Ref, SetupContext } from '@nuxtjs/composition-api'
import { Modifier, Options } from '@popperjs/core'
import maxSize from 'popper-max-size-modifier'

import useProxyValue from '@/composables/use-proxy-value'
import useShowable from '@/composables/use-showable'

/**
 * 限制選單的最大寬度和高度以避免溢出視窗外
 * https://www.npmjs.com/package/popper-max-size-modifier
 */
const applyMaxSize = {
  name: 'applyMaxSize',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['maxSize'],
  fn ({ state }) {
    const { height } = state.modifiersData.maxSize
    state.styles.popper = {
      ...state.styles.popper,
      maxHeight: `${height}px`,
    }
  },
} as Partial<Modifier<'applyMaxSize', {}>>

export default function (
  value: Ref,
  emit: SetupContext['emit']
) {
  const options: Options = {
    placement: 'bottom-start',
    strategy: 'absolute',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10],
        },
      },
      maxSize,
      applyMaxSize,
    ],
  }

  const { isShow, show, hide } = useShowable()
  const save = () => emit('save')
  const saveAndHide = () => {
    if (!isShow.value) return // 只有選單為顯示狀態時才會執行
    save()
    hide()
  }

  const { proxyValue } = useProxyValue(value, emit)
  const clear = () => { proxyValue.value = undefined }

  return {
    options,

    isShow,
    show,
    hide,
    saveAndHide,
    proxyValue,
    save,
    clear,
  }
}
